var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading app-datetime-picker",
    class: {
      'app-datetime-picker--sm': _vm.size === 'sm'
    }
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('datepicker', _vm._b({
    staticClass: "app-datetime-picker",
    class: {
      'app-datetime-picker--is-invalid': _vm.hasError,
      'app-datetime-picker--sm': _vm.size === 'sm'
    },
    attrs: {
      "placeholder": _vm.placeholder,
      "bootstrap-styling": "",
      "format": "yyyy/MM/dd",
      "language": _vm.zh,
      "popover-align": "center",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.datetime,
      callback: function callback($$v) {
        _vm.datetime = $$v;
      },
      expression: "datetime"
    }
  }, 'datepicker', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }